<div mat-dialog-content class="dialog d-flex flex-column justify-content-between align-items-center">

    <video controls>
        <source [src]="videoLink">
    </video>

    <!-- <a [href]="videoLink" target="_blank" download>Télécharger ma vidéo</a> -->

</div>